import { render, staticRenderFns } from "./BehaviorManage.vue?vue&type=template&id=9a86ec78&scoped=true"
import script from "./BehaviorManage.vue?vue&type=script&lang=js"
export * from "./BehaviorManage.vue?vue&type=script&lang=js"
import style0 from "./BehaviorManage.vue?vue&type=style&index=0&id=9a86ec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a86ec78",
  null
  
)

export default component.exports